import { selectElementAsync } from "../../../utils/utils";

/**
 * 販売実績の１行目の販売明細Noにフォカスする
 */
export async function selectFirstSalesResultsAsync() {
  selectElementAsync(`salesResults-0-0`, 100);
}
